module.exports = __webpack_public_path__ + "static/media/point_difference.6972ab41.svg";